import { useState, useEffect } from 'react';

const useOverflowDetection = (ref, isSmallView: boolean, setIsWideContainer?: (isWide: boolean) => void) => {
  const [containerWidth, setContainerWidth] = useState(0);
  const [totalWidth, setTotalWidth] = useState(0);
  const [lastIndexInView, setLastIndexInView] = useState(-1);

  useEffect(() => {
    if (ref.current) {
      const containerWidth = ref.current.clientWidth;
      const scrollWidth = ref.current.scrollWidth;
      const isWide = containerWidth <= scrollWidth;
      const children = ref.current.children;
      let totalWidth = 0;
      const childrenArray = Array.from(children);

      // Iterate over the children and calculate total width
      for (let [index, child] of childrenArray.entries()) {
        const remainingSpace = containerWidth - totalWidth;
        totalWidth += child.offsetWidth;

        // If totalWidth doesn't exceed container width or if part of the child fits
        if (totalWidth <= containerWidth || remainingSpace > 0) {
          setLastIndexInView(index);
        }
      }

      // Update the state with the calculated values
      setTotalWidth(totalWidth);
      setContainerWidth(containerWidth);

      // Optional: Adjust the container width flag based on whether it's wide
      if (!isSmallView && isWide) {
        setIsWideContainer?.(containerWidth <= totalWidth);
      }
    }
  }, [ref.current?.className, isSmallView, setIsWideContainer]);

  return { containerWidth, totalWidth, lastIndexInView };
};

export default useOverflowDetection;